import { useState, useRef, useEffect } from 'react';

import Debouncer from '../lib/util/Debouncer';

// Hook
/**
 *
 */
function useDebounce<T>(value: T, delay = 500): T {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const debouncer = useRef(new Debouncer(value, delay));

  useEffect(
    () => {
      debouncer.current.setValue(value, () => {
        setDebouncedValue(value);
      });
    },
    [value, delay], // Only re-call effect if value or delay changes
  );

  return debouncedValue;
}

export default useDebounce;
